<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">支付信息</div>
            <div class="mb20">
                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="待支付金额">
                        <div>￥{{ allMoney }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="支付方式">
                        <div>{{ CheckServiceDiscountCate(orderDetails.Orders_DiscountCate ) > 0 && awaitPayValue != 6 ? '在线付款' : '线下付款' }}</div>
                    </el-descriptions-item>
                    <div class="error" v-if="orderDetails.Select == 'false'">
                        {{ orderDetails.Message }}
                    </div>
                    <el-descriptions-item label="付款凭证" v-if="orderDetails.Orders_Payway==6||orderDetails.Orders_Payway==0">
                        <div>
                            <div>
                                <el-button size="mini" type="primary" @click="chooseVoucher">选择凭证</el-button>
                                <span style="color: red; margin-left: 10px">若有多张凭证请全部选择后再点击“提交”按钮</span>
                            </div>
                            <div style="margin-top: 10px" v-if="ReceiptList && ReceiptList.length > 0">
                                <el-table :data="ReceiptList" ref="Table" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Receipt_ID" label="ID" width="120" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Code" label="汇款单位" align="center" width="200" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Amount" label="汇款金额" align="center"></el-table-column>
                                    <el-table-column prop="Receipt_Addtime" label="录入时间" align="center"></el-table-column>
                                    <el-table-column prop="residuePrice" label="本次分配金额" align="center">
                                        <template slot-scope="scope">
                                            {{ jsonShowData.Receipt_Amount.split(',')[scope.$index].split('|')[1] }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="移除" align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" @click="removeClk(scope.$index)">移除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="button-container" v-if="orderDetails && orderDetails.Select != 'false'">
                <el-button type="primary" @click="submit">
                    {{ orderDetails.Orders_AuditStatus != 1 ? '保存' : '提交' }}
                </el-button>
            </div>
            <el-dialog title="选择凭证" :visible.sync="isShowVoucher" width="1200px" :before-close="handleClose" v-if="isShowVoucher" append-to-body>
                <PackOrderVoucher :cateid="cateid" :residuePrice="residuePrice" @getPaymentReceipts="getPaymentReceipts"></PackOrderVoucher>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import PackOrderVoucher from '@/components/packOrderVoucher';

export default {
    components: {
        PackOrderVoucher
    },
    props: {
        OrdersID: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            // OrdersID: '', //合同id
            relate_orders: [],
            list: [],
            nowIndex: 0, //当前选择凭证的列表索引
            cateid: '', //当前选择凭证的id
            residuePrice: 0, //当前选择凭证的剩余金额
            isShowVoucher: false, //是否显示凭证列表
            awaitPayValue: 0, //待付金额
            orderDetails: {}, //订单详情
            allMoney: 0, //总代付金额
            payenable: false, //是否可以支付
            ReceiptList: [], //凭证列表
            jsonShowData: {
                //凭证列表参数
                Receipt_ID: '',
                Receipt_Amount: ''
            }
        };
    },
    mounted() {
        // const params = this.$route.query;
        // if (params) {
        //     this.OrdersID = params.orderId;
        //     this.getOrdersByID();
        // }
        console.log(9999, this.OrdersID);
        if (this.OrdersID) {
            this.getOrdersByID();
        }
    },
    methods: {
        //
        CheckServiceDiscountCate(discountCate)
        {
        //销售订单
            let result = 0;
            switch (discountCate)
            {
                case "W":
                case "G":
                case "B":
                    //有偿服务
                    result = 1;
                    break;
                case "H":
                    //人工服务
                    result = 2;
                    break;
            }
            return result;
        },
        async getOrdersByID() {
            let result = await this.$newsApi.order.getOrdersByID({
                ID: this.OrdersID,
                ifBack: true
            });

            this.orderDetails = {
                ...result.data.data,
                addressDetails: '',
                projectDetails: ''
            };
            this.awaitPayValue = 6;
            if ( this.CheckServiceDiscountCate(this.orderDetails.Orders_DiscountCate)> 0 && this.orderDetails.Orders_Payway != 6) {
                this.awaitPayValue = this.orderDetails.Orders_Payway;
            }
            if (this.orderDetails.Orders_IsNoCustomerSign == 1) {
                this.$message('免盖章订单，请注意付款金额需等于订单金额！');
            }
            this.CheckOrdersPay();
        },
        async CheckOrdersPay() {
            let result = await this.$newsApi.order.Office_CheckOrdersPay({
                OrdersID: this.OrdersID,
                ifBack: true
            });
            this.remianpay = Number(result.data.data);
            this.allMoney = Number(result.data.data); //总代付金额
            this.payenable = true;
        },
        // 选择凭证
        chooseVoucher() {
            this.residuePrice = this.remianpay;
            this.isShowVoucher = true;
        },
        // 保存
        async submit() {
            let json = JSON.stringify({ Orders_ID: this.OrdersID, Payway_ID: this.awaitPayValue, Receipt_ID: this.jsonShowData.Receipt_ID, Receipt_Amount: this.jsonShowData.Receipt_Amount });
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Orders_Pay({
                Json: json
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                if (result.data.Resultinfo != 'Online') {
                    this.$emit('OrderPayRes', false);
                } else if (result.data.Resultinfo == 'Online') {
                    let Orders_SN = this.orderDetails.Orders_SN;
                    this.webUrl = this.$payWebUrl + '/pay/office_index.aspx?orders_sn=' + Orders_SN;
                    window.open(this.webUrl);
                }
            }
        },
        handleClose(done) {
            this.isShowVoucher = false;
        },
        // 凭证列表
        getPaymentReceipts(json) {
            // 需要整和当前所有的Receipt_Amount,Receipt_ID参数
            if (this.ReceiptList.length > 0) {
                json['Receipt_ID'] = this.jsonShowData.Receipt_ID + ',' + json['Receipt_ID'];
                json['Receipt_Amount'] = this.jsonShowData.Receipt_Amount + ',' + json['Receipt_Amount'];
                this.ShowOrdersPaymentReceipt(json);
            } else {
                this.ShowOrdersPaymentReceipt(json);
            }
        },
        // 显示凭证列表
        async ShowOrdersPaymentReceipt(e) {
            let json = JSON.stringify(e);
            let result = await this.$newsApi.order.ShowOrdersPaymentReceipt({
                Json: json
            });
            this.jsonShowData.Receipt_ID = result.data.data.Receipt_ID;
            this.jsonShowData.Receipt_Amount = result.data.data.Receipt_Amount;
            this.ReceiptList = result.data.data.list;

            let arr = result.data.data.Receipt_Amount.split(',');
            let num = 0;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i]) {
                    num += Number(arr[i].split('|')[1]);
                }
            }
            if (num < this.allMoney) {
                this.remianpay = (this.allMoney - num).toFixed(2);
            } else {
                this.remianpay = 0;
            }
            this.isShowVoucher = false;
        },
        // 移除
        removeClk(e) {
            this.$confirm('确定删除当前凭证吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (this.ReceiptList.length > 1) {
                        let a = this.jsonShowData.Receipt_Amount.split(',');
                        this.jsonShowData.Receipt_Amount = a.splice(e, 1).join();
                        let b = this.jsonShowData.Receipt_ID.split(',');
                        this.jsonShowData.Receipt_ID = b.splice(e + 1, 1).join();
                        this.ReceiptList.splice(e, 1);
                        this.remianpay = this.remianpay + Number(this.jsonShowData.Receipt_Amount.split(',')[e].split('|')[1]);
                    } else {
                        this.receiptShow = false;
                        this.jsonShowData.Receipt_Amount = '';
                        this.jsonShowData.Receipt_ID = '';
                        this.ReceiptList = [];
                        this.remianpay = this.allMoney;
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
</style>